export enum FreeGameType {
  MainGame = 0,
  YummyFreeGame = 1,
  HeavenlyFreeGame = 2,
}
